import { isBefore } from 'date-fns'

export type CampaignCreationIneligibilityReason = 'expired' | 'fullyAllocated'

type CampaignEligibility =
  | { canCreateCampaign: true }
  | { canCreateCampaign: false; reason: CampaignCreationIneligibilityReason }

export const checkCanCreateCampaign = ({
  airEndTime,
  unallocatedImpressions,
}: {
  airEndTime: string | null
  unallocatedImpressions: number
}): CampaignEligibility => {
  const now = new Date()

  if (airEndTime !== null && !isBefore(now, new Date(airEndTime))) {
    return { canCreateCampaign: false, reason: 'expired' }
  }

  if (unallocatedImpressions <= 0) {
    return { canCreateCampaign: false, reason: 'fullyAllocated' }
  }

  return { canCreateCampaign: true }
}
